export default __webpack_public_path__ + "static/9-f8908b4ce001285ce0050f44475ce9ed.webp";